import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Avatar,
  useTheme,
  alpha,
} from '@mui/material';
import { AccountTree, DevicesOther, Lan } from '@mui/icons-material';
import { a11yProps } from './rede/monitoramentoRedeUtils';
import { useDispositivosRede } from './rede/useDispositivosRede';
import { useRedeDiagrama } from './rede/useRedeDiagrama';
import DiagramaTab from './rede/DiagramaTab';
import DispositivosTab from './rede/DispositivosTab';
import DispositivosTabHeader from './rede/DispositivosTabHeader';

const TAB_DIAGRAMA = 0;
const TAB_DISPOSITIVOS = 1;

const MonitoramentoRedePage: React.FC = () => {
  const theme = useTheme();
  const primario = theme.palette.primary.main;
  const [tab, setTab] = useState(TAB_DIAGRAMA);
  const diagramaState = useRedeDiagrama(tab === TAB_DIAGRAMA);
  const dispositivosState = useDispositivosRede(tab === TAB_DISPOSITIVOS);

  return (
    <Box sx={{ p: 0.5, height: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Paper
        elevation={2}
        sx={{
          mb: 0,
          borderRadius: 2,
          overflow: 'hidden',
          background: `linear-gradient(135deg, ${alpha(primario, 0.04)} 0%, ${alpha(theme.palette.secondary.main, 0.04)} 100%)`,
        }}
      >
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar sx={{ bgcolor: alpha(primario, 0.12), color: primario, width: 40, height: 40 }}>
              <Lan sx={{ fontSize: 22 }} />
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight={800} sx={{ fontSize: '1.05rem', lineHeight: 1.2 }}>
                Monitoramento de Rede
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.72rem' }}>
                Gerencie dispositivos, acompanhe ping e status da infraestrutura
              </Typography>
            </Box>
          </Box>
          {tab === TAB_DISPOSITIVOS && <DispositivosTabHeader {...dispositivosState} />}
        </Box>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            px: 1,
            borderTop: `1px solid ${theme.palette.divider}`,
            bgcolor: alpha(theme.palette.background.paper, 0.6),
            '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, fontSize: '0.82rem', minHeight: 42, gap: 0.8 },
          }}
        >
          <Tab icon={<AccountTree sx={{ fontSize: 18 }} />} iconPosition="start" label="Diagrama" {...a11yProps(TAB_DIAGRAMA)} />
          <Tab icon={<DevicesOther sx={{ fontSize: 18 }} />} iconPosition="start" label="Dispositivos" {...a11yProps(TAB_DISPOSITIVOS)} />
        </Tabs>
      </Paper>

      <Box sx={{ flex: 1, minHeight: 520 }}>
        {tab === TAB_DIAGRAMA ? (
          <Paper
            key="tab-diagrama"
            elevation={3}
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <DiagramaTab diagramaState={diagramaState} />
          </Paper>
        ) : (
          <Box
            key="tab-dispositivos"
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              overflow: 'auto',
            }}
          >
            <DispositivosTab dispositivosState={dispositivosState} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MonitoramentoRedePage;
